module.exports = __webpack_public_path__ + "static/img/LK.8855cfc0.png";